import { GridAnimation } from "./GridAnimation";
import { ChevronDown } from "lucide-react";
import { LogoIcon } from "@/components/ui/Logo";

export function Hero() {
  const scrollToAbout = () => {
    document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <GridAnimation />

      <div className="relative z-10 text-center px-4">
        <LogoIcon className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 mx-auto mb-6 text-accent" />
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light tracking-tight text-foreground mb-6">
          Bakerysoft
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground font-light tracking-wide">
          Building apps that delight
        </p>
      </div>

      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-muted-foreground hover:text-foreground transition-colors duration-300 animate-bounce"
        aria-label="Scroll to content"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
